export default "__VITE_PUBLIC_ASSET__79c0c78f__"